import PropTypes from 'prop-types';
import { Camera } from 'lucide-react';
import { Text } from '@/components/ui/index.js';
import styles from './ImageGallery.module.css';

/**
 * ImageGallery - Hero image gallery for venue detail
 * Shows main large image and thumbnail grid
 */
export function ImageGallery({ images, venueName, onViewAll }) {
  const mainImage = images[0];
  const thumbnails = images.slice(1, 4);
  const remainingCount = images.length - 4;
  
  return (
    <div className={styles.gallery}>
      {/* Main Image */}
      <div className={styles.mainImageContainer}>
        <div className={styles.mainImagePlaceholder}>
          <div className={styles.imageIcon}>
            <Camera size={48} />
          </div>
          <Text color="muted" size="sm">Main Image</Text>
        </div>
        
        {/* View All Button */}
        {images.length > 1 && (
          <button 
            onClick={onViewAll}
            className={styles.viewAllButton}
          >
            <Camera size={16} />
            <Text size="sm" weight="medium">
              View All {images.length} Photos
            </Text>
          </button>
        )}
      </div>
      
      {/* Thumbnails Grid */}
      {thumbnails.length > 0 && (
        <div className={styles.thumbnails}>
          {thumbnails.map((image, index) => (
            <div 
              key={index} 
              className={styles.thumbnail}
            >
              <div className={styles.thumbnailPlaceholder}>
                <Camera size={20} />
              </div>
            </div>
          ))}
          
          {/* Show remaining count on last thumbnail */}
          {remainingCount > 0 && (
            <div className={styles.thumbnail}>
              <div className={styles.thumbnailOverlay}>
                <Text size="lg" weight="bold" color="primary">
                  +{remainingCount}
                </Text>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

ImageGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.number).isRequired,
  venueName: PropTypes.string.isRequired,
  onViewAll: PropTypes.func.isRequired,
};

export default ImageGallery;
